var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data"},[_c('second-menu-link-content',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('span',[_vm._v("数据")])]},proxy:true},{key:"content",fn:function(){return [_c('P',[_vm._v("数据内容")])]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }